<div class="edit-cards-dialog">
  <h1 class="m-0 text-center">Creacion de Banners</h1>

  <div class="row">
    <div class="col-6">
      <div class="icon-wrapper">
        <img [src]="data.img64 ? data.img64 : 'assets/images/default-user-example.jps'" class="card-icon" alt="">
        <button mat-icon-button class="fixed-button save-button" (click)="openUploadFiles()">
          <mat-icon>camera_alt</mat-icon>
        </button>
        <input
          #inputFiles
          style="display: none"
          type="file"
          (change)="handleUpload($event)"
        />
      </div>
    </div>
    <div class="col-6 d-flex align-items-end">
      <div class="mb-3">
        <h5 class="m-0 font-weight-bold">Descripción de imagen</h5>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput disabled placeholder="Descripción de imagen" [(ngModel)]="data.img">
        </mat-form-field>
      </div>
    </div>
    <div class="col-6">
      <div class="mb-3">
        <h5 class="m-0 font-weight-bold">Título</h5>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput placeholder="Título" [(ngModel)]="data.title">
        </mat-form-field>
      </div>
    </div>
    <div class="col-6">
      <div class="mb-3">
        <h5 class="m-0 font-weight-bold">Texto de botón</h5>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput placeholder="Texto de botón" [(ngModel)]="data.nameButton1">
        </mat-form-field>
      </div>
    </div>
    <div class="col-6">
      <div class="mb-3">
        <h5 class="m-0 font-weight-bold">Sub Título</h5>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput placeholder="Sub título" [(ngModel)]="data.subTitle">
        </mat-form-field>
      </div>
    </div>
    <div class="col-6">
      <div class="mb-3">
        <h5 class="m-0 font-weight-bold">Link de redirección</h5>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput placeholder="Link de redirección" [(ngModel)]="data.urlButton1  ">
        </mat-form-field>
      </div>
    </div>
    <div class="col-6">
      <div class="mb-3">
        <h5 class="m-0 font-weight-bold">Sub Título 2</h5>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput placeholder="subtitulo 2" [(ngModel)]="data.subTitle2  ">
        </mat-form-field>
      </div>
    </div>

    <div class="col-6">
      <div class="mb-3">
        <h5 class="m-0 font-weight-bold">Orden</h5>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput type="number" placeholder="orden" [(ngModel)]="data.order">
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center">
    <button mat-flat-button class="save-button m-3" [disabled]="!data.img64" [mat-dialog-close]="data">Guardar</button>
    <button mat-flat-button color="warn" class="m-3" mat-dialog-close>Cancelar</button>
  </div>
</div>
